import { AxiosInstance } from "axios";
import { isAex } from "@/brand";

import { ParserUrlGenerator } from "./url-generator";
import { ParserParseRequest, ParserResponse } from "./repo";

import { downloadFile } from "@/shared/utils/file-helpers";

export interface ParserProjectRepository {
  parse(payload: ParserParseRequest): Promise<void>;
}

export class ParserHttpRepo implements ParserProjectRepository {
  constructor(
    private readonly axios: AxiosInstance,
    private readonly urlGenerator: ParserUrlGenerator
  ) {}

  async parse(payload: ParserParseRequest): Promise<void> {
    // Supplied references contain no AEX agreement templates. Never send MEX
    // legal documents as AEX agreements; enable this after AEX templates arrive.
    if (isAex)
      throw new Error("Документ временно недоступен. Свяжитесь с info@aex.cx.");
    const { data } = await this.axios.post<ParserResponse>(
      this.urlGenerator.parse(),
      payload
    );

    downloadFile(
      data.docxFile,
      `${payload.fileName}.docx`,
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    );
  }
}
